import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Gtp } from 'src/app/shared/gtp';
import { AccesosSistemaService } from 'src/app/services/admin/accesos-sistema/accesos-sistema.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-accesos-al-sistema',
  templateUrl: './accesos-al-sistema.component.html',
  styleUrls: ['./accesos-al-sistema.component.scss']
})
export class AccesosAlSistemaComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  pageEvent: PageEvent;

  public loading: boolean = false;
  public contClass: string = 'container-fluid maincont';
  public dataSource: MatTableDataSource<any>;
  public tableCount: number = 0;
  public tableDisplay: boolean = false;

  // Estadísticas
  public estadisticas: any = null;
  public chartData: any = null;
  public mostrarGrafico: boolean = false;
  public chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          boxWidth: 12,
          font: {
            size: 11
          }
        }
      }
    }
  };

  public filter: any = {
    limite: 10,
    fecha_desde: '',
    fecha_hasta: '',
    buscar: '',
    orderby: 'fecha',
    sortby: 'desc',
    pageIndex: 0,
    pageSize: 10,
  };

  // Columnas: fecha, hora, usuario, aplicación, IP, navegador, SO, dispositivo, estado
  displayedColumns: string[] = ['fecha', 'hora', 'user_aplicacion', 'nombre_aplicacion', 'ip_publica', 'navegador', 'sistema_operativo', 'dispositivo', 'ingreso'];

  constructor(
    private gtp: Gtp,
    private cdRef: ChangeDetectorRef,
    private accesosService: AccesosSistemaService
  ) { }

  ngOnInit(): void {
    // El backend ya filtra por usuario logueado automáticamente
    this.cargarDatos();
    this.cargarEstadisticas();
  }

  ngAfterViewInit() {
    // Se configura después de que la vista se inicialice
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  cargarDatos(): void {
    this.loading = true;

    this.accesosService.getUltimosAccesos(this.filter).subscribe(
      (response) => {
        if (response.success) {
          // El backend ya filtra IPs y procesa los datos
          this.dataSource = new MatTableDataSource(response.data);
          this.tableCount = response.data.length;
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.loading = false;
          this.tableDisplay = true;
        }
      },
      (error) => {
        console.error('Error al cargar accesos:', error);
        this.loading = false;
      }
    );
  }

  cargarEstadisticas(): void {
    const filtrosFecha = {
      fecha_desde: this.filter.fecha_desde,
      fecha_hasta: this.filter.fecha_hasta
    };

    this.accesosService.getEstadisticasAccesos(filtrosFecha).subscribe(
      (response) => {
        if (response.success) {
          this.estadisticas = response.data;
          this.actualizarGraficos();
        }
      },
      (error) => {
        console.error('Error al cargar estadísticas:', error);
      }
    );
  }

  actualizarGraficos(): void {
    if (!this.estadisticas || !this.estadisticas.resumen) return;

    // Gráfico de dona - Accesos exitosos vs fallidos
    this.chartData = {
      labels: ['Exitosos', 'Fallidos'],
      datasets: [{
        data: [
          this.estadisticas.resumen.accesos_exitosos,
          this.estadisticas.resumen.accesos_fallidos
        ],
        backgroundColor: [
          '#4CAF50',
          '#f44336'
        ],
        hoverBackgroundColor: [
          '#45a049',
          '#da190b'
        ]
      }]
    };
  }

  toggleGrafico(): void {
    this.mostrarGrafico = !this.mostrarGrafico;
  }

  containerSize() {
    this.contClass = this.gtp.containerSize(this.contClass);
  }

  cerrarTabla() {
    this.gtp.cerrarVentanas(true);
  }

  setSort(event?) {
    this.filter.orderby = event.active;
    this.filter.sortby = event.direction;
  }

  setPagination(event?) {
    this.filter.pageIndex = parseInt(event.pageIndex);
    this.filter.pageSize = parseInt(event.pageSize);
    return event;
  }

  getPageSizeOptions(): number[] {
    return [5, 10, 20, 50, this.tableCount];
  }

  applyFilter() {
    this.dataSource.filter = this.filter.buscar.trim().toLowerCase();
  }

  aplicarFiltros(): void {
    this.cargarDatos();
    this.cargarEstadisticas();
  }

  limpiarFiltros(): void {
    this.filter = {
      limite: 10,
      fecha_desde: '',
      fecha_hasta: '',
      buscar: '',
      orderby: 'fecha',
      sortby: 'desc',
      pageIndex: 0,
      pageSize: 10,
    };
    this.aplicarFiltros();
  }

  formatearHora(hora: string): string {
    if (!hora) return '';
    // Si viene como HH:MM:SS.mmm o HH:MM:SS, extraer solo HH:MM:SS
    const partes = hora.split('.');
    return partes[0]; // Retorna HH:MM:SS
  }


  getIpLabel(ip: string): string {
    if (ip && ip.trim() === '38.52.134.42') {
      return 'acceso-soporte-dev';
    }
    return ip;
  }

  getIpClass(ip: string): string {
    if (ip && ip.trim() === '38.52.134.42') {
      return 'ip-badge-soporte';
    }
    return 'ip-badge-small';
  }

  getStatusClass(ingreso: boolean): string {
    return ingreso ? 'status-success' : 'status-error';
  }

  getStatusText(ingreso: boolean): string {
    return ingreso ? 'OK' : 'Error';
  }

  getStatusIcon(ingreso: boolean): string {
    return ingreso ? 'check' : 'close';
  }

  exportarDatos(): void {
    if (!this.dataSource || !this.dataSource.data || this.dataSource.data.length === 0) {
      alert('No hay datos para exportar');
      return;
    }

    // Preparar datos para exportar
    const datosExportar = this.dataSource.data.map(acceso => ({
      Fecha: new Date(acceso.fecha).toLocaleDateString('es-PY'),
      Hora: this.formatearHora(acceso.hora),
      Usuario: acceso.user_aplicacion,
      Aplicación: acceso.nombre_aplicacion,
      IP: acceso.ip_publica,
      Navegador: acceso.navegador,
      'Sistema Operativo': acceso.sistema_operativo,
      Dispositivo: acceso.dispositivo,
      Estado: this.getStatusText(acceso.ingreso)
    }));

    // Convertir a CSV
    const headers = Object.keys(datosExportar[0]);
    const csvContent = [
      headers.join(','), // Encabezados
      ...datosExportar.map(row =>
        headers.map(header => {
          const value = row[header] || '';
          // Escapar comillas y envolver en comillas si contiene comas
          return value.toString().includes(',') ? `"${value}"` : value;
        }).join(',')
      )
    ].join('\n');

    // Crear archivo y descargar
    const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    const fecha = new Date().toISOString().split('T')[0];
    link.setAttribute('href', url);
    link.setAttribute('download', `accesos_sistema_${fecha}.csv`);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
